import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

export const StyledMapModal = styled.div`
  position: fixed;
  left: 0px;
  right: 0px;
  width: 90%;
  max-width: 1000px;
  height: 86vh;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  z-index: 1000;
  border-radius: 20px 20px 0 0;
  padding: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  bottom: 0px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    box-sizing: border-box;
    max-width: 100%;
    width: 100%;
  }
`;

export const MapContainer = styled.div`
  flex: 1;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 16px;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }
`;
